export const PAGE_HEADER_TYPES = {
  SIMPLIFIED: 'Simplified Page Header',
  STANDARD: 'Standard Page Header',
} as const;

export const PAGE_FOOTER_TYPES = {
  SIMPLIFIED: 'Simplified Page Footer',
  STANDARD: 'Standard Page Footer',
} as const;
